/* eslint-disable no-param-reassign */
import { getField, updateField } from 'vuex-map-fields';
import { mapKeys, snakeCase } from 'lodash';
import axios from 'axios';
import moment from 'moment';
import * as MutationTypes from '@/store/mutation-types';
import InvestmentEntitiesApi from '@/backend/api/InvestmentEntities';
import { fetchResource } from '../../utils';
import { assignHelper, fetchList } from '../helpers';

const initialForm = {
  firstname: '',
  country: 'France',
  registrationNumber: '',
  companyType: '',
  lastname: '',
  address: '',
  zipCode: '',
  city: '',
  birthDate: '',
  birthCity: '',
  birthCountry: 'France',
};

export default {
  namespaced: true,
  state: {
    list: [],
    show: null,
    form: initialForm,
  },
  mutations: {
    [MutationTypes.SET_INVESTMENT_ENTITIES]: assignHelper('list'),
    [MutationTypes.SET_INVESTMENT_ENTITY](state, entity) {
      state.show = entity;
      if (entity) {
        state.form = entity.data.attributes;
        if (state.form.birthDate) {
          state.form.birthDate = moment(state.form.birthDate).format('DD/MM/YYYY');
        }
        if (state.form.registrationNumber) {
          state.form.registrationNumber = state.form.registrationNumber
            .replace(/\D/g, '').substr(0, 9)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ').substr(0, 11);
        }
      }
    },
    updateField,
    [MutationTypes.UPDATE_REGISTRATION_NUMBER](state, value) {
      state.form.registrationNumber = value;
    },
    [MutationTypes.UPDATE_FORM_FROM_API](state, siegeSocial) {
      state.form.zipCode = siegeSocial.code_postal;
      state.form.address = siegeSocial.l4_normalisee;
      state.form.city = siegeSocial.libelle_commune;
      state.form.lastname = siegeSocial.nom_raison_sociale;
      state.form.companyType = siegeSocial.libelle_nature_juridique_entreprise;
    },
    [MutationTypes.RESET](state) {
      state.form = initialForm;
    },
  },
  getters: {
    getField,
  },
  actions: {
    fetch: fetchResource(InvestmentEntitiesApi, MutationTypes.SET_INVESTMENT_ENTITY),
    fetchList: fetchList(InvestmentEntitiesApi, MutationTypes.SET_INVESTMENT_ENTITIES),
    chooseEntity({ dispatch }, { opportunityId, chosenEntityId }) {
      return InvestmentEntitiesApi.choose(opportunityId, chosenEntityId).then(() => {
        dispatch('opportunity/fetch', { id: opportunityId, force: true }, { root: true });
      });
    },
    create({ state, dispatch }, { kind, opportunityId }) {
      return InvestmentEntitiesApi.create(
        opportunityId,
        {
          ...mapKeys(state.form, (_, key) => snakeCase(key)),
          kind,
        },
      ).then(() => {
        if (opportunityId) {
          dispatch('opportunity/fetch', { id: opportunityId, force: true }, { root: true });
        }
      });
    },
    update({ state }) {
      return InvestmentEntitiesApi.update(state.form);
    },
    updateRegistrationNumber({ commit }, value) {
      commit(MutationTypes.UPDATE_REGISTRATION_NUMBER, value);
      if (value.length !== 11) {
        return null;
      }
      const normalizedSiren = value.replace(/\s/g, '');
      const promise = axios.get(`https://entreprise.data.gouv.fr/api/sirene/v1/siren/${normalizedSiren}`)
        .then((response) => {
          commit(MutationTypes.UPDATE_FORM_FROM_API, response.data.siege_social);
        });
      return promise;
    },
  },
};
